import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOP_ModuleSummary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Module Summary"
      videos={[]} // No specific video links provided
      takeaways={[
        { text: "Focus more on the theoretical concepts and example codes." },
        { text: "Be clear about all definitions and use cases of each method covered in this module." },
        { text: "Coding questions can be expected, so have a basic overview and practice some problems." },
        { text: "In exams, always write the expected output after the code (even if the logic is incorrect) to increase your chances of scoring more marks." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
);
}

export default OOP_ModuleSummary;
